<div class="container">
  <div class="row">
    <div class="col bg-white order-wrapper">
      <button (click)="toggleOrderList()" type="button"
              class="btn btn-sm btn-light mt-3 float-end d-lg-block">{{i18n.get('global_close')}}</button>
      <h1 class="h3 pb-2 mb-2 border-bottom">{{i18n.get('orders_title', 'orders')}}</h1>
      <div *ngIf="!ready">
        <app-spinner></app-spinner>
      </div>
      <div *ngIf="ready">
        <ul class="nav nav-tabs">
          <li class="nav-item" *ngIf="hasAOS()">
            <a class="nav-link mouse-pointer" [ngClass]="tab === 'aos' ? 'active' : ''" (click)="tab = 'aos'">
              {{i18n.get('orders_last_aos_orders', 'orders')}}
            </a>
          </li>
          <ng-container *ngFor="let tool of tools">
            <ng-container *ngIf="tool.activeorderlisttab">
              <li class="nav-item">
                <a class="nav-link mouse-pointer"
                   [ngClass]="tab === 'generic-' + tool.toolid ? 'active' : ''"
                   (click)="loadGenericToolOrderList(tool)">
                  {{getToolLabel(tool)}}
                </a>
              </li>
            </ng-container>
          </ng-container>
        </ul>
        <ng-container *ngIf="tab === 'aos'">
          <app-aos-orders></app-aos-orders>
        </ng-container>
        <ng-container *ngIf="tab !== 'aos'">
          <app-generic-orders-list [currentOrderListTool$]="currentOrderListTool$">
          </app-generic-orders-list>
        </ng-container>
      </div>
    </div>
  </div>
</div>
